import * as Api from "../../utils/api";

const API = process.env.REACT_APP_MQN_BASE;

export const search = async data => Api.post(`search`, data, API);

export const databases = async data => Api.get(`databases`, data, API);